import Button from 'components/base/Button';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { defaultBreadcrumbItems } from 'data/commonData';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';

const AddNew = () => {
  return (
    <div>
      <PageBreadcrumb items={defaultBreadcrumbItems} />
      <h2 className="mb-4">Adicionar Nova Sinalização</h2>
      <Row>
        <Col xs={12} xl={9}>
          <Row as="form" className="g-3 mb-6">
            <Col sm={6} md={8}>
              <FloatingLabel
                controlId="floatingSignalName"
                label="Nome da Sinalização"
              >
                <Form.Control type="text" placeholder="Nome da Sinalização" />
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel
                controlId="floatingSignalType"
                label="Tipo de Sinalização"
              >
                <Form.Select>
                  <option>Selecionar tipo</option>
                  <option value="1">Advertência</option>
                  <option value="2">Proibição</option>
                  <option value="3">Obrigação</option>
                  <option value="4">Emergência</option>
                  <option value="5">Informação</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel
                controlId="floatingSignalCategory"
                label="Categoria"
              >
                <Form.Select>
                  <option>Selecionar categoria</option>
                  <option value="1">Segurança</option>
                  <option value="2">Trânsito</option>
                  <option value="3">Industrial</option>
                  <option value="4">Comercial</option>
                  <option value="5">Pública</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel
                controlId="floatingSignalPriority"
                label="Prioridade"
              >
                <Form.Select>
                  <option>Selecionar prioridade</option>
                  <option value="1">Baixa</option>
                  <option value="2">Média</option>
                  <option value="3">Alta</option>
                  <option value="4">Crítica</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel controlId="floatingSignalStatus" label="Status">
                <Form.Select>
                  <option>Selecionar status</option>
                  <option value="1">Ativo</option>
                  <option value="2">Inativo</option>
                  <option value="3">Em Manutenção</option>
                  <option value="4">Aguardando Aprovação</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col sm={6} md={4}>
              <FloatingLabel
                controlId="floatingSignalLocation"
                label="Localização"
              >
                <Form.Control type="text" placeholder="Localização" />
              </FloatingLabel>
            </Col>
            <Col xs={12} className="gy-6">
              <FloatingLabel
                controlId="floatingSignalDescription"
                label="Descrição da Sinalização"
              >
                <Form.Control
                  as="textarea"
                  placeholder="Descreva a sinalização..."
                  style={{ height: '100px' }}
                />
              </FloatingLabel>
            </Col>
            <Col md={6} className="gy-6">
              <FloatingLabel
                controlId="floatingSignalResponsible"
                label="Responsável"
              >
                <Form.Select>
                  <option>Selecionar responsável</option>
                  <option value="1">João Silva</option>
                  <option value="2">Maria Santos</option>
                  <option value="3">Pedro Oliveira</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
            <Col md={6} className="gy-6">
              <FloatingLabel
                controlId="floatingSignalBudget"
                label="Orçamento (R$)"
              >
                <Form.Control type="number" placeholder="0,00" />
              </FloatingLabel>
            </Col>
            <Col md={6} className="gy-6">
              <FloatingLabel
                controlId="floatingSignalCode"
                label="Código da Sinalização"
              >
                <Form.Control type="text" placeholder="Ex: SIN-001" />
              </FloatingLabel>
            </Col>
            <Col md={6} className="gy-6">
              <FloatingLabel
                controlId="floatingSignalDimensions"
                label="Dimensões (cm)"
              >
                <Form.Control type="text" placeholder="Ex: 30x40" />
              </FloatingLabel>
            </Col>
            <Col xs={12} className="gy-6">
              <FloatingLabel
                controlId="floatingSignalObservations"
                label="Observações"
              >
                <Form.Control
                  as="textarea"
                  placeholder="Observações adicionais..."
                  style={{ height: '80px' }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={12} className="gy-6">
              <div className="d-flex justify-content-end gap-3">
                <Button variant="phoenix-primary" className="px-5">
                  Cancelar
                </Button>
                <Button variant="primary" className="px-5 px-sm-15">
                  Criar Sinalização
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default AddNew;
